import globalActions from '../api/GlobalActions.js'
import globalMutations from '../api/GlobalMutations.js'
import globalGetters from '../api/GlobalGetters.js'

export const state = () => ({
  isStale: true,
  latest_fetch: '',
  type: 'files',
  pageLayout: 'LayoutStructureTable',
  canEdit: false,
  canView: false,
  modelLabels: {
    single: 'File',
    plural: 'Files'
  },
  filterOverrides: [],
  aliasField: 'filename',
  relations: [
    {
      name: 'tags',
      translate: 'tags',
      label: 'Tags',
      value: 'tags',
      storename: 'tags',
      export: false
    }
  ],
  all: {
  },
  active: false,
  searchFields: ['filename'],
  bound: {
    name: ''
  },
  filter: {},
  quickFilters: [],
  stub: {},
  include: ''
})

// Mutations ==================

export const mutations = {
  ...globalMutations
}

// Actions ====================

export const actions = {
  ...globalActions
}

// Getters ====================

export const getters = {
  ...globalGetters
}
